import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { User, UserRole } from '../../models/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JwtService } from '../../services/jwt.service';

@Component({
  selector: 'app-account',
  imports: [CommonModule, FormsModule],
  templateUrl: './account.component.html',
  styleUrl: './account.component.css'
})
export class AccountComponent implements OnInit {
  user: User | null = null;
  UserRole = UserRole;
  decodedToken: any = null;
  pictureUrl: string | null = null;

  constructor(private loginService: LoginService, private jwtService: JwtService) {}

  ngOnInit(): void {
    this.user = this.loginService.user;

    // Decode the JWT token to get all available fields
    const token = localStorage.getItem('jwt');
    if (token) {
      this.decodedToken = this.jwtService.decodeToken(token);
      console.log('Decoded Token in Account:', this.decodedToken);
      console.log('Picture URL:', this.decodedToken?.picture);
      console.log('User Picture:', this.user?.picture);

      // Store the picture URL to prevent it from disappearing
      this.pictureUrl = this.decodedToken?.picture || this.user?.picture || null;
    }
  }

  getRoleName(role: UserRole): string {
    switch(role) {
      case UserRole.Admin: return 'Admin';
      case UserRole.Creator: return 'Creator';
      case UserRole.Agent: return 'Agent';
      case UserRole.Research: return 'Research';
      case UserRole.Scouting: return 'Scouting';
      case UserRole.Casting: return 'Casting';
      default: return 'None';
    }
  }

  getTokenExpirationDate(): string {
    if (!this.decodedToken) return 'N/A';

    // Check multiple possible field names
    const exp = this.decodedToken.exp || this.decodedToken.expiration || this.decodedToken.expires;
    if (!exp) return 'N/A';

    const date = new Date(exp * 1000);
    return date.toLocaleString();
  }

  getTokenIssuedDate(): string {
    if (!this.decodedToken) return 'N/A';

    // Check multiple possible field names
    const iat = this.decodedToken.iat || this.decodedToken.issuedAt || this.decodedToken.issued;
    if (!iat) {
      // If no iat field exists in the token, return N/A
      return 'Not available in token';
    }

    const date = new Date(iat * 1000);
    return date.toLocaleString();
  }

  getUserId(): string {
    return this.decodedToken?.sub || this.decodedToken?.userId || this.user?.id || 'N/A';
  }

  getAuthIdentity(): string {
    return this.decodedToken?.authIdentity || this.decodedToken?.sub || this.user?.authIdentity || 'N/A';
  }

  getFullName(): string {
    // Try to get name from user object first
    if (this.user?.firstName || this.user?.lastName) {
      return `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim();
    }

    // Fall back to decoded token fields
    if (this.decodedToken) {
      const firstName = this.decodedToken.given_name || this.decodedToken.firstName || '';
      const lastName = this.decodedToken.family_name || this.decodedToken.lastName || '';
      const fullName = `${firstName} ${lastName}`.trim();
      if (fullName) return fullName;

      // Try name field directly
      if (this.decodedToken.name) return this.decodedToken.name;
    }

    return 'Not provided';
  }

  getEmail(): string {
    return this.user?.email || this.decodedToken?.email || 'Not provided';
  }

}
